export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14902.ba0ff48f.jpg";